import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { certificates, gradientColor } from "./constants";

function Certificates() {
  return (
    <Box id="certificates" sx={{ marginBottom: 15 }}>
      <Typography
        variant="h4"
        sx={{
          marginBottom: 5,
          background: gradientColor,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: "800 !important",
          textAlign: "center",
          color: "#333333",
          position: "relative",
          fontSize: {
            xs: "1.5rem",
            md: "2.125rem",
          },
        }}
      >
        Certificates & Accreditations
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          padding: "0 10px",
        }}
      >
        {certificates.map((certificate, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              width: "90%",
              maxWidth: "600px",
              padding: "10px 30px",
              textAlign: "left",
              position: "relative",
              borderRadius: "15px",
              mb: index === certificates.length - 1 ? 0 : 3,
            }}
          >
            <certificate.icon
              sx={{
                position: "absolute",
                left: "20px",
                top: "20px",
                width: "40px",
                height: "40px",
              }}
            />
            <Box sx={{ marginLeft: "50px" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", marginBottom: 1, color: "#333" }}
              >
                {certificate.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#666", marginBottom: 1 }}
              >
                {certificate.description}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}

export default Certificates;
